import { IKeyObjectiveTag } from 'legacy/lut/classes/models/partner360/IFormOptionsJBP'
import { useMemo } from 'react'

import { FormMultiselect } from 'cng-common/features/form'
import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

interface IKeyObjectiveTagsProps {
  keyObjectiveTagsSettingsList: IKeyObjectiveTag[]
  formKey: string
  initialValue: string[]
  programType: string
  rtm: string
  label?: string
  placeholder?: string
}

export const KeyObjectiveTags = ({
  programType,
  keyObjectiveTagsSettingsList,
  formKey,
  rtm,
  initialValue,
  label,
  placeholder,
}: IKeyObjectiveTagsProps) => {
  const filteredKeyObjectiveTags = useMemo(
    () =>
      keyObjectiveTagsSettingsList.filter((item) => {
        const isRtmMatch = !item.rtm || item.rtm.includes(rtm)
        const isOfferingMatch = !item.offerings || item.offerings.includes(programType)

        return isRtmMatch && isOfferingMatch
      }),
    [keyObjectiveTagsSettingsList, programType, rtm]
  )

  const keyObjectiveTagsCrud = useMemo(() => {
    return new Crud({
      fetcher: new Static(filteredKeyObjectiveTags),
      keyField: 'key',
      defaultPaging: {
        page: 0,
        pageSize: filteredKeyObjectiveTags.length,
      },
    })
  }, [filteredKeyObjectiveTags])

  return (
    <FormMultiselect
      isStatic
      formKey={formKey}
      field="keyObjectiveTags"
      defaultValue={initialValue}
      source={keyObjectiveTagsCrud}
      caption="key"
      label={label}
      placeholder={placeholder}
      margin={'sm'}
    />
  )
}
